import React from 'react';

type Props = {
	type: 'entities' | 'utterances';
};

export function Empty(props: Props) {
	const { type } = props;
	return (
		<p
			style={{
				marginTop: 16,
				color: '#7D7D7D',
				fontSize: 15,
			}}
		>
			You've yet to add any {type}. Please include a new one.
		</p>
	);
}
